// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pricing Plans — compact layout */

.pp-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 100px);
  min-height: 480px;
  max-height: calc(100vh - 88px);
}

.pp-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.pp-toolbar-note {
  font-size: 15px;
  color: #94a3b8;
  flex: 1 1;
}

.pp-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.pp-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.pp-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.pp-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.pp-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.pp-btn--primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.pp-btn--danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.pp-category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  flex: 1 1;
  align-content: start;
  padding-top: 8px;
}

.pp-category-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.pp-category-card:hover {
  border-color: #93c5fd;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);
}

.pp-category-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eff6ff;
  color: #2563eb;
}

.pp-category-card:nth-child(2) .pp-category-icon {
  background: #f1f5f9;
  color: #475569;
}

.pp-category-card:nth-child(3) .pp-category-icon {
  background: #ecfdf5;
  color: #059669;
}

.pp-category-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.pp-category-desc {
  font-size: 15px;
  color: #64748b;
  line-height: 1.45;
  margin: 0;
}

.pp-category-meta {
  font-size: 13px;
  color: #94a3b8;
  margin-top: auto;
}

.pp-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  flex-shrink: 0;
}

.pp-toast button {
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.pp-toast--err {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.pp-table-panel {
  flex: 1 1;
  min-height: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pp-table-scroll {
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.pp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.pp-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fafbfc;
  padding: 9px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #e2e8f0;
}

.pp-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
}

.pp-table tbody tr:hover {
  background: #f8fafc;
}

.pp-plan-name {
  display: block;
  font-weight: 600;
  color: #0f172a;
}

.pp-plan-desc {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 2px;
}

.pp-badge {
  font-size: 14px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  text-transform: uppercase;
}

.pp-badge--active {
  background: #dcfce7;
  color: #166534;
}

.pp-badge--inactive {
  background: #f1f5f9;
  color: #64748b;
}

.pp-actions {
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}

.pp-icon-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pp-table tbody tr:hover .pp-icon-btn {
  color: #94a3b8;
}

.pp-icon-btn:hover:not(:disabled) {
  background: #f1f5f9;
  color: #475569;
}

.pp-icon-btn--danger:hover:not(:disabled) {
  background: #fef2f2;
  color: #dc2626;
}

.pp-empty,
.pp-loading {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #94a3b8;
  font-size: 15px;
  padding: 24px;
}

.pp-spin {
  animation: pp-spin 0.8s linear infinite;
}

@keyframes pp-spin {
  to { transform: rotate(360deg); }
}

/* Modals */
.pp-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  padding: 16px;
}

.pp-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.pp-modal--sm {
  max-width: 400px;
}

.pp-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.pp-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.pp-modal-close {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pp-modal-body {
  padding: 16px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.pp-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
}

.pp-field {
  margin-bottom: 12px;
}

.pp-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
}

.pp-field input,
.pp-field select,
.pp-field textarea {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  box-sizing: border-box;
}

.pp-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.pp-form-row .pp-field {
  margin-bottom: 0;
}

.pp-feature-row {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
}

.pp-feature-row input {
  flex: 1 1;
}

.pp-checks {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 15px;
  color: #475569;
}

.pp-checks label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.pp-confirm-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fef2f2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.pp-confirm-text {
  text-align: center;
  font-size: 15px;
  color: #64748b;
}

@media (max-width: 900px) {
  .pp-category-grid {
    grid-template-columns: 1fr;
  }

  .pp-page {
    height: auto;
    max-height: none;
  }

  .pp-form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/website/PricingPlansManager.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,SAAO;EACP,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Pricing Plans — compact layout */\n\n.pp-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: calc(100vh - 100px);\n  min-height: 480px;\n  max-height: calc(100vh - 88px);\n}\n\n.pp-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.pp-toolbar-note {\n  font-size: 15px;\n  color: #94a3b8;\n  flex: 1;\n}\n\n.pp-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.pp-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.pp-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.pp-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.pp-btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.pp-btn--primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.pp-btn--danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.pp-category-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  flex: 1;\n  align-content: start;\n  padding-top: 8px;\n}\n\n.pp-category-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 16px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.pp-category-card:hover {\n  border-color: #93c5fd;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);\n}\n\n.pp-category-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.pp-category-card:nth-child(2) .pp-category-icon {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.pp-category-card:nth-child(3) .pp-category-icon {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.pp-category-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n}\n\n.pp-category-desc {\n  font-size: 15px;\n  color: #64748b;\n  line-height: 1.45;\n  margin: 0;\n}\n\n.pp-category-meta {\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: auto;\n}\n\n.pp-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.pp-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.pp-toast--err {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.pp-table-panel {\n  flex: 1;\n  min-height: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.pp-table-scroll {\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.pp-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 15px;\n}\n\n.pp-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fafbfc;\n  padding: 9px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.pp-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: middle;\n}\n\n.pp-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.pp-plan-name {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.pp-plan-desc {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n.pp-badge {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n  text-transform: uppercase;\n}\n\n.pp-badge--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.pp-badge--inactive {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.pp-actions {\n  display: flex;\n  gap: 4px;\n  justify-content: flex-end;\n}\n\n.pp-icon-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #cbd5e1;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pp-table tbody tr:hover .pp-icon-btn {\n  color: #94a3b8;\n}\n\n.pp-icon-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.pp-icon-btn--danger:hover:not(:disabled) {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.pp-empty,\n.pp-loading {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 15px;\n  padding: 24px;\n}\n\n.pp-spin {\n  animation: pp-spin 0.8s linear infinite;\n}\n\n@keyframes pp-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Modals */\n.pp-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  padding: 16px;\n}\n\n.pp-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 32px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);\n}\n\n.pp-modal--sm {\n  max-width: 400px;\n}\n\n.pp-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.pp-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.pp-modal-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pp-modal-body {\n  padding: 16px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.pp-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.pp-field {\n  margin-bottom: 12px;\n}\n\n.pp-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 5px;\n}\n\n.pp-field input,\n.pp-field select,\n.pp-field textarea {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  box-sizing: border-box;\n}\n\n.pp-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.pp-form-row .pp-field {\n  margin-bottom: 0;\n}\n\n.pp-feature-row {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.pp-feature-row input {\n  flex: 1;\n}\n\n.pp-checks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  font-size: 15px;\n  color: #475569;\n}\n\n.pp-checks label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.pp-confirm-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #fef2f2;\n  color: #dc2626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 12px;\n}\n\n.pp-confirm-text {\n  text-align: center;\n  font-size: 15px;\n  color: #64748b;\n}\n\n@media (max-width: 900px) {\n  .pp-category-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pp-page {\n    height: auto;\n    max-height: none;\n  }\n\n  .pp-form-row {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
